import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BooleanPipe, NoDataComponent } from '@web/shared/ui';
import { isNotEmptyArray, isNotNil } from '@web/utils';
import {
  Accordion,
  AccordionContent,
  AccordionHeader,
  AccordionPanel,
} from 'primeng/accordion';
import { SummernoteHtmlPreviewComponent } from '@web/shared/external';
import { AdminBoxSaleMissingItemPickStrategyComponent } from '../admin-box-sale-missing-item-pick-strategy/admin-box-sale-missing-item-pick-strategy.component';
import { BoxComponentGroupCosmeticsTableComponent } from '@web/shared/module/shop';
import { AdminBoxSaleGroupItem } from '../../models/admin-box-sale-details-form';

@Component({
  selector: 'app-admin-box-sale-groups-preview',
  imports: [
    Accordion,
    AccordionContent,
    AccordionHeader,
    AccordionPanel,
    BooleanPipe,
    CommonModule,
    NoDataComponent,
    SummernoteHtmlPreviewComponent,
    AdminBoxSaleMissingItemPickStrategyComponent,
    BoxComponentGroupCosmeticsTableComponent,
  ],
  templateUrl: './admin-box-sale-groups-preview.component.html',
  styleUrl: './admin-box-sale-groups-preview.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AdminBoxSaleGroupsPreviewComponent {
  public readonly groups = input.required<AdminBoxSaleGroupItem[]>();
  public readonly showAvailableQuantity = input(true);
  public readonly showRemainingQuantity = input(true);

  protected readonly isNotEmptyArray = isNotEmptyArray;
  protected readonly isNotNil = isNotNil;
}
